import { Routes } from '@angular/router';
import { customersSettingsChildRoutes } from '../features/settings/settings-child-routes.routes';
import { appRoutes } from '../shared/constants/routes.constants';

export const applicationChildRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: appRoutes.CUSTOMERS,
  },
  {
    path: appRoutes.CUSTOMERS,
    loadComponent: () => import('../features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: appRoutes.CUSTOMERS + '/:id',
    loadComponent: () => import('../layout/settings-layout/settings-layout.component').then((m) => m.SettingsLayoutComponent),
    children: customersSettingsChildRoutes,
  },
  {
    path: appRoutes.SUPER_ADMINS,
    loadComponent: () => import('../features/super-admins/super-admins.component').then((m) => m.SuperAdminsComponent),
  },
];
